import React, { useState, useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import api from '../utils/api';
import '../css/auth.css';


export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post('/auth/login', { email, password });
      const { token, user } = res.data;

      if (token && user) {
        login(token, user);
        navigate('/');
      }
    } catch (err) {
      console.error('Login Error:', err);
      alert('Login failed: ' + (err.response?.data?.message || 'Check credentials'));
    } finally {
      setLoading(false);
    }
  };

    // ❌ OLD:
// window.location.href = `${process.env.REACT_APP_API_URL || 'http://localhost:5000/api'}/auth/google`;

// ✅ UPDATE TO:
// const handleGoogleAuth = () => {
 // window.location.href = `${process.env.REACT_APP_API_URL || 'https://invensys.africa/api'}/auth/google`;
// };



  return (
    <div className="auth-container">
    <div className="shell">

      <div className="screens">
        <div className="screen active">
          <div className="scroll-body pt-24">
            <div className="display">Welcome<br /><em>back</em></div>
            <div className="lead">Log in to enter your creative horizon.</div>

            <form onSubmit={handleLogin}>
              <div className="field">
                <span className="label">Email Address</span>
                <input
                  type="email"
                  className="input"
                  placeholder="name@domain.com"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <div className="field">
                <span className="label">Password</span>
                <div className="input-wrap">
                  <input
                    type={showPassword ? 'text' : 'password'}
                    className="input"
                    placeholder="••••••••••••"
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <div className="input-icon" onClick={() => setShowPassword(!showPassword)}>👁</div>
                </div>
              </div>

              <button type="submit" className="btn-primary mt-16" disabled={loading}>
                {loading ? 'Verifying...' : 'Login'}
              </button>
            </form>

            <div className="divider">or</div>


            <div className="terms-note mt-24">
              Don't have an account? <Link to="/signup" style={{ color: 'var(--glow)' }}>Create one here</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
}